import { render, staticRenderFns } from "./FeaturedResource.vue?vue&type=template&id=6098b4af&scoped=true&"
import script from "./FeaturedResource.vue?vue&type=script&lang=js&"
export * from "./FeaturedResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6098b4af",
  null
  
)

export default component.exports